// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"60e9d968","272":"60e9d968"}[chunkId] + ".chunk.css";
};